module.exports = __webpack_public_path__ + "static/media/right.d9c99b98.jpg";